import React, { createContext, useContext, useState, useCallback } from "react";
import { tr, Dict } from "./tr";
import { en } from "./en";

export type Lang = "tr" | "en";
const DICTS: Record<Lang, Dict> = { tr, en };
const DEFAULT_LANG = (process.env.REACT_APP_DEFAULT_LANG as Lang) || "tr";

interface I18nCtx {
  lang: Lang;
  setLang: (l: Lang) => void;
  d: Dict;
}

const Ctx = createContext<I18nCtx>({ lang: DEFAULT_LANG, setLang: () => {}, d: DICTS[DEFAULT_LANG] });

export const I18nProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lang, setLangState] = useState<Lang>(() => {
    const saved = typeof window !== "undefined" ? (localStorage.getItem("sdip.lang") as Lang) : null;
    return saved || DEFAULT_LANG;
  });
  const setLang = useCallback((l: Lang) => {
    setLangState(l);
    try { localStorage.setItem("sdip.lang", l); } catch {}
  }, []);
  return <Ctx.Provider value={{ lang, setLang, d: DICTS[lang] }}>{children}</Ctx.Provider>;
};

export function useI18n() {
  return useContext(Ctx);
}
